import React from 'react';
import styled from 'styled-components'

import { Icon } from '../common';

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 16px;
`

const Star = styled.div`
    margin: 0 1px;
`

export const RatingStars = ({score}) => (
    <Wrapper>
        {Array(score).fill(score).map(i => (
            <Star>
                <Icon name={"star"} />
            </Star>
        ))}
    </Wrapper>
)

